<template>
  <div>
    <v-container fluid class="pa-0">
      <v-row class="pa-5">
        <v-col cols="12">
          <v-card class="d-flex">
            <!-- Gastos -->
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
                
              >
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      range
                      label="Rango de fechas"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" range no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      CANCELAR
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">
                      ACEPTAR
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              
              <v-col cols="12" md="3">
                <v-btn @click="consultar" color="primary" class="mt-3"
                  >Consultar datos</v-btn
                >
              </v-col>
              <v-btn
                @click="dialog=true"
                color="success"
                fab
                large
                dark
                class="float-right"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-row>
            <v-dialog
              v-model="dialog"
              persistent
              max-width="500px"
            >
              <!-- <template v-slot:activator="{ on, attrs }">
                <v-col cols="3">
                  
                </v-col>
              </template> -->
              <v-card>
                <v-card-title>
                  <span class="headline">{{ "Nuevo gasto" }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-menu
                          :close-on-content-click="false"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="spendItem.spend_date"
                              label="Fecha de compra"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="spendItem.spend_date"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="spendItem.description"
                          label="Descripcion"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="spendItem.type"
                          :items="tipos"
                          label="Tipo"
                          item-text="name"
                          item-value="id"
                          persistent-hint
                          single-line
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="spendItem.amount"
                          label="Cantidad gastada"
                          type="number"
                        ></v-text-field>
                      </v-col>
                      
                      <!-- {{rol}} -->
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="saveSpend">
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialog2"
              persistent
              max-width="500px"
              v-if="reporte === 1"
            >
              <!-- <template v-slot:activator="{ on, attrs }">
                <v-col>
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="success"
                    fab
                    large
                    dark
                    class="d-none"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </template> -->
              <v-card>
                <v-card-title>
                  <span class="headline">{{
                    itemToView === null ? "Nuevo corte" : "Detalles del corte"
                  }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row v-if="itemToView === null">
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.inBox"
                          label="En caja"
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <!-- {{rol}} -->
                    </v-row>
                    <v-row v-if="itemToView != null">
                      <v-col cols="12" sm="12" md="12">
                        <p>
                          <b>Efectivo:</b> <br />
                          {{ itemToView ? itemToView.efective : "" }}
                        </p>
                        <p>
                          <b>Efectivo gastado:</b> <br />
                          {{ itemToView ? itemToView.efectiveSpend : "" }}
                        </p>
                        <p>
                          <b>Dinero en caja:</b> <br />
                          {{ itemToView ? itemToView.inBox : "" }}
                        </p>
                        <p>
                          <b>Total:</b> <br />
                          {{
                            itemToView &&
                            itemToView.inBox &&
                            itemToView.efective &&
                            itemToView.efectiveSpend
                              ? Number(itemToView.inBox) +
                                Number(itemToView.efective) -
                                Number(itemToView.efectiveSpend)
                              : ""
                          }}
                        </p>
                        <p>
                          <b>Usuario:</b> <br />
                          {{
                            itemToView && itemToView.user
                              ? itemToView.user.name
                              : ""
                          }}
                        </p>
                        <p>
                          <b>Fecha del corte:</b> <br />
                          {{
                            itemToView
                              ? formattedDate(itemToView.initDate) +
                                " - " +
                                formattedDate(itemToView.endDate)
                              : ""
                          }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cerrar
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    v-if="itemToView === null"
                    text
                    @click="save"
                  >
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- <v-col cols="3" v-if="reporte == 1">
              <v-btn @click="consultar" color="success" class="mt-3"
                >Nuevo corte</v-btn
              >
            </v-col> -->
          </v-card>
        </v-col>
        <v-col>
          <v-data-table
            item-key="_id"
            class="elevation-1"
            :headers="headers"
            :items="items"
            :search="search"
            :single-expand="true"
            :show-expand="reporte == 3"
            :loading="loading"
            loading-text="Cargando..."
          >
            
            <template v-if="reporte == 0" #item.spend_date="{ item }">{{
              item ? formattedDate(item.spend_date) : ""
            }}</template>
            <template v-if="reporte == 0" #item.type="{ item }">{{
              item.type=='0' ? 'Nómina' : item.type=='1'?'General':''
            }}</template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewItem(item)">
                mdi-eye
              </v-icon>
            </template>
            
            <template
              v-if="reporte == 3"
              v-slot:expanded-item="{ headers, item }"
            >
              <td :colspan="headers.length">
                <v-row>
                  <v-col>
                    <h5>DETALLE VENTA</h5>
                    <div
                      v-for="(detail, index) in item.sale_detail"
                      :key="index"
                    >
                      <span>
                        {{
                          detail.product
                            ? "Producto: " + detail.product
                              ? detail.product.name
                              : ""
                            : "Servicio: " + detail.service
                            ? detail.service.name
                            : ""
                        }}</span
                      >
                      <span> Cantidad: {{ detail.quantity }} </span>
                      <span> Precio: {{ detail.price }} </span>
                    </div>
                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import ReportsService from "../services/reports";
export default {
  name: "Cortes",
  data() {
    return {
      tipos: [{id:0,name:'Nómina'},{id:1,name:'General'}],
      sesion: JSON.parse(sessionStorage.getItem("sesion")),
      search: null,
      loading: false,
      dialog: false,
      dialog2: false,
      reporte: 1,
      headers: [{}],
      items: [],
      inicio: null,
      fin: null,
      date: [],
      menu: false,
      cliente: null,
      orden: null,
      itemToView: null,
      corteHoy:null,
      ultimoCorte:null,
      editedItem: {
        inBox: 0,
      },
      spendItem: {
        description: "",
        type: null,
        amount: 0,
        spend_date: "",
        user: "",
      },
      arrStatus: [
        { id: 0, name: "CANCELADAS" },
        { id: 1, name: "ACTIVAS" },
        { id: 2, name: "TODAS" },
      ],
      status: 2,
      rules: {
        required: (value) => !!value || "Requerido.",
        min: (v) => v.length >= 8 || "Minimo 8 caracteres",
      },
    };
  },
  created(){
    this.setDate()
  },
  mounted() {
    this.corteActual()
  },
  components: {
    // ImprimirVenta
  },
  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialog2(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    setDate(){
      let hoy = new Date()
      this.date[1] = moment(hoy).format('YYYY-MM-DD')
      let before7 = moment(hoy).subtract(7, 'days')
      this.date[0] = moment(before7).format('YYYY-MM-DD')
    },
    clear() {
      console.log(this.reporte);
      this.headers = [];
      this.items = [];
    },
    consultar() {
      this.loading = true;
      this.headers = [];
      this.items = [];
      this.getGastos()
    },
    getGastos() {
      let parametros;
      if (this.status == 2) {
        parametros = {
          spend_date: {
            $gte: this.date[0],
            $lt:
              this.date[1] ||
              this.date[0],
          },
        };
      } else {
        parametros = {
          spend_date: {
            $gte: this.date[0],
            $lt:
              this.date[1] ||
              this.date[0],
          },
        };
      }

      console.log(parametros);
      this.headers = [
        { text: "Descripcion", value: "description" },
        { text: "Usuario", value: "user.name" },
        // { text: "Automovil", value: "vehiculo" },
        { text: "Fecha", value: "spend_date" },
        { text: "Tipo", value: "type" },
        { text: "Monto", value: "amount" },
      ];

      ReportsService.gastosByFilter(parametros)
        .then((res) => {
          console.log(res);
          this.items = res.data;
          if (res.data && res.data.length > 0) {
            let total = 0;
            this.items.forEach((element) => {
              total += element.amount;
            });
            this.items.push({
              description: "Total",
              amount: total,
            });
          }
          console.log(this.items);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCortes() {
      this.headers = [
        { text: "Tarjeta de crédito", value: "creditCard" },
        // { text: "RFC", value: "rfc" },
        { text: "Efectivo", value: "efective" },
        { text: "En caja", value: "inBox" },
        { text: "Fecha de inicio", value: "initDate" },
        { text: "Fecha de fin", value: "endDate" },
        { text: "Usuario", value: "user.name" },
        { text: "Acciones", value: "actions" },
      ];
      ReportsService.cortes()
        .then((res) => {
          console.log(res);
          this.items = res.data;
          console.log(this.items);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    corteActual(){
      ReportsService.corteUltimo(this.sesion._id).then(corte=>{
        this.ultimoCorte=corte.data
      })
    },
    formattedDate(date) {
      return moment(date).format("YYYY-MM-DD hh:mm A");
    },
    close() {
      this.itemToView = null;
      this.dialog = false;
      this.dialog2 = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.spendItem);
        this.editedIndex = -1;
      });
    },
    save() {
      let itemToSend = {
        inBox: this.corteHoy,
        user: this.sesion._id,
      }
      ReportsService.corteNuevo(itemToSend).then((res) => {
        // console.log(res.data);
        this.itemToView = res.data
        this.getCortes()
        this.corteActual()
        this.corteHoy=null
      })
    },
    saveSpend() {
      let itemToSend = {
        ...this.spendItem,
      };
      itemToSend = {
        ...itemToSend,
        spend_date: moment(itemToSend.spend_date).toISOString(),
        user: this.sesion._id,
      };
      ReportsService.gastoNuevo(itemToSend).then((res) => {
        console.log(res.data);
        this.getGastos();
        this.close();
      });
      console.log(itemToSend);
    },
    viewItem(item) {
      this.itemToView = Object.assign({}, item);
      console.log(this.itemToView);
      this.dialog2 = true;
    },
    cancelacionCorte(id){
      ReportsService.corteBorrar(id).then(()=>{
        this.initialize()
      })
    }
  },
};
</script>